import React from "react";
import ViewAttendance from "../../components/StaffTabs/StaffTimeTable/ViewAttendance";

const AttendanceView = () => {
  return (
    <div>
      <ViewAttendance />
    </div>
  );
};

export default AttendanceView;
